<template>
<div class="task-details-make-container">
    <task-details-header  @taskStatusId="getTaskStatusId" @allowOperate="setAllowOperate" @viewStatusId="getViewStatusId" @taskEvaluation="getTaskEvaluation"></task-details-header>
    <el-tabs type="border-card">
        <el-tab-pane :label="$t('comb.taskAnchor')">
            <div class="anchor-info-container" v-loading.body="anchorLoading">
            <div v-if="anchor.anchorId">
                <img :src="anchor.anchorPic || 'http://fdfs.test.ximalaya.com/group1/M00/3C/26/wKgDplhk3i2ADxL_AAA3c-AGB9M155.jpg'" alt="">
                <div class="info-right">
                    <div>
                        <p class="anchor-name"><a :href="`${$store.state.XMLY_INDEX_URL}zhubo/${anchor.anchorId}`" target="_blank">{{anchor.anchorName}}</a><i class="icon icon-vip" :class="vipIconClass" style="margin-right: 15px;"></i><span>{{ $t('word.fans') }}：{{anchor.fansCount|formatNumber}}</span></p>
                        <p class="anchor-num"><span>{{ $t('comb.personalIntro') }}：</span><span class="oneLine">{{anchor.personalSignature}}</span></p>
                        <p class="anchor-num"><span>{{ $t('comb.contractTime') }}：</span><span>{{anchor.contractTime}}</span></p>
                    </div>
                    <div>
                        <!--<p class="look-up"><span>已更新{{breachCount}}次</span><a @click="lookUpBreak">查看</a></p>-->
                        <p class="operate">
                            <!-- <el-button size="small" v-if="taskStatusId===1" @click="enforce()">结束合作</el-button> -->
                        </p>
                    </div>
                </div>
            </div>
        </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('comb.albumManagement')">
            <div class="album-management">
                <div class="album-info-wrapper">
                    <div class="image-wrapper">
                        <img :src="`${UPLOAD_IMG_HOST}${albumForm.coverPath}`">
                    </div>
                    <div class="album-info">
                        <div style="margin-bottom: 10px;"><span class="title">专辑名称：</span><a v-if="albumForm.albumStatus === 1" :href="getAlbumUrl" target="_blank">《{{ albumForm.title }}》</a><span v-else="">《{{ albumForm.title }}》</span></div>
                        <span v-if="albumForm.paid" key="albumForm.albumId">专辑售价：{{ albumForm.price }}</span><span v-else key="albumForm.albumId">免费专辑</span>
                        <span v-show="albumForm.paid">折扣价格：{{ albumForm.discountPrice }}</span>
                        <span v-show="albumForm.paid">免费集数：{{ albumForm.freeEpisode }}</span>
                    </div>
                </div>
                <el-button v-show="albumForm.paid && allowOperate && albumForm.albumStatus === 1" class="on-sale-button" :class="{'on-sale-button-middle': !albumForm.isOnSale}" type="primary" @click.native="albumDialog=true;">{{ albumForm.isOnSale? '专辑调价':$t('comb.albumOnSale') }}</el-button>
            </div>
        </el-tab-pane>
    </el-tabs>
    <div class="voice-works-list" v-loading.body="voiceLoading">
        <div class="works-item" v-for="(item,index) in taskWorksList" :sound_id="item.taskWorkId" :sound_src="`${UPLOAD_IMG_HOST}${item.defaultUrl}`" :sound_duration="item.duration" sound_playusage="2">
            <div class="works-item-index">{{ totalVoiceCount-(pageSize*(currentPage-1))-index}}</div>
            <div class="works-item-content">
                <div>
                    <div class="download-wrapper">
                        <p class="works-name">{{item.fileName}}</p>
                        <!--<a :href="`${UPLOAD_IMG_HOST}${item.defaultUrl}`" download>下载音频</a>-->
                        <a :href="`/api/requirement/${item.requirementId}/task/work/${item.taskWorkId}/download`" download>下载音频</a>
                    </div>
                    <div class="xm-player">
                        <i class="player_btn"></i>
                        <div class="player_progressbar">
                            <div class="player_seekbar"></div>
                            <div class="player_playbar"></div>
                            <div class="player_wavebox" :sound_wave="`${UPLOAD_IMG_HOST}${item.waveForm}`" :sound_uploadid="`u_${item.fileId}`"></div>
                        </div>
                        <div>
                            <span class="player_position">00:00</span> /
                            <span class="player_duration">{{item.duration|format-audio-time}}</span>
                        </div>
                    </div>
                </div>
                <div class="status-date-wrapper">
                    <span class="status-label">{{ item.statusLabel }}</span>
                    <span class="date">{{formatDate(item.createTime)}}</span>
                </div>
            </div>
        </div>
        <div class="pagination" v-if="totalPage>=2">
            <el-pagination @current-change="changePage" :current-page="currentPage" :page-count="totalPage" layout="prev, pager, next"></el-pagination>
        </div>
    </div>
    <el-dialog :title="multiWarmTips" v-model="dialogVisible" :lock-scroll="false" size="small" @close="closeDialog">
        <div class="rate-item">
            <span>{{ $t('comb.recordQuality') }}</span>
            <el-rate :disabled="rateDisabled" @change="changeRecordQualityScore" v-model="recordQualityScore" :colors="['#99A9BF', '#F7BA2A', '#fc5832']"></el-rate>
        </div>
        <div class="rate-item">
            <span>{{ $t('comb.serviceAttitude') }}</span>
            <el-rate :disabled="rateDisabled" @change="changeAttitudeScore" v-model="attitudeScore" :colors="['#99A9BF', '#F7BA2A', '#fc5832']"></el-rate>
        </div>
        <div class="rate-item">
            <span>{{ $t('comb.responseSpeed') }}</span>
            <el-rate :disabled="rateDisabled" @change="changeSpeedScore" v-model="speedScore" :colors="['#99A9BF', '#F7BA2A', '#fc5832']"></el-rate>
        </div>
        <div class="evaluate-content">
            <span>{{ $t('comb.taskEvaluate') }}</span>
            <textarea :readonly="rateDisabled" :placeholder="multiEvaluateContentMissing" v-model="taskEvaluation"></textarea>
        </div>
        <div slot="footer" class="dialog-footer" v-if="!rateDisabled">
            <el-button @click="closeRate" size="small">{{ $t('word.cancel') }}</el-button>
            <el-button @click="submitEvaluate" :loading="submitEvaluateBtnStatus" :disabled="submitEvaluateBtnStatus" type="primary" size="small">{{ $t('word.ok') }}</el-button>
        </div>
    </el-dialog>
    <el-dialog v-model="breakDialog" :lock-scroll="false" size="small" :title="multiBreakRecord">
        <div v-for="item in monthBreachCount" class="break-item">
            <span>{{item.month}}</span><span>{{ $t('word.uploadBreak') }}{{item.count}}{{ $t('word.times') }}</span>
        </div>
        <div v-if="monthBreachCount.length===0">{{ $t('sen.noBreakRecord') }}</div>
    </el-dialog>
    <el-dialog :title="$t('comb.albumPricing')" v-model="albumDialog" size="small">
            <el-form ref="albumForm" :model="albumForm" label-width="80px" label-position="left">
                <div style="margin-left: 30px;">
                    <el-form-item :label="$t('comb.voicePrice')">
                        <el-input-number :controls="false" :min="0" v-model="albumForm.price" size="small"></el-input-number>
                    </el-form-item>
                    <el-form-item :label="$t('comb.voiceDiscountPrice')">
                        <el-input-number :controls="false" :min="0" v-model="albumForm.discountPrice" size="small"></el-input-number>
                    </el-form-item>
                    <el-form-item :label="$t('comb.freeEpisode')">
                        <el-input-number :disabled="albumForm.isOnSale" :controls="false" :min="0" v-model="albumForm.freeEpisode" size="small"></el-input-number>
                    </el-form-item>
                </div>
                <div class="order-buttons">
                    <el-button type="primary" @click.native="commitAlbum">{{ $t('word.ok') }}</el-button>
                    <el-button @click.native="albumDialog=false;">{{ $t('word.cancel') }}</el-button>
                </div>
            </el-form>
    </el-dialog>
</div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import TaskDetailsHeader from './TaskDetailsHeader.vue';
export default {
    components: {
      axios, moment, TaskDetailsHeader
    },
    data() {
        return {
            voiceLoading: true,         // whether show progressbar when loading voice list
            anchorLoading: true,        // whether show progressbar when loading anchor info
            allowOperate: true,         // 是否允许版权方操作
            anchor: {
              anchorId: '',
              anchorName: '',
              anchorPic: '',
              contractTime: '',
              personalSignature: '',
              fansCount: 0,
              anchorGrade: 0,
              verifyType: 1
            },
            taskId: '',
            taskWorksList: [],
            taskStatusId: 0,
            viewStatusId: 0,
            totalPage: 0,
            totalVoiceCount: 0,
            dialogVisible: false,
            recordQualityScore: 0,
            attitudeScore: 0,
            speedScore: 0,
            taskEvaluationObj: '',
            taskEvaluation: '',
            submitEvaluateBtnStatus: false,
            rateDisabled: false,
            breachCount: 0,
            breakDialog: false,
            albumDialog: false,
            monthBreachCount: [],
            pageIndex: 1,
            currentPage: 1,
            taskInfoLoading: true,          // where show progressbar when loading task info.
            albumForm: {
              albumId: '',
              albumStatus: '',      // 专辑质检状态
              andhorId: '',
              coverPath: '',
              title: '',
              paid: false,          // 是否付费专辑
              price: 0,
              discountPrice: 0,
              freeEpisode: 0,
              isOnSale: false
            }
        };
    },
    mounted() {
        this.getAnchorInfo();
        this.getAlbumInfo();
        this.getVoiceList();
    },
    methods: {
        getAnchorInfo() {
            const id = this.$route.params.id;
            const that = this;
            axios.get(`/api/manager/requirement/${id}/anchor`).then(result => {
                if (result.data.code == 200) {
                    const res = result.data.data;
                    that.anchor.anchorName = res.nickname;
                    that.anchor.anchorId = res.uid;
                    that.anchor.fansCount = res.fansCount;
                    that.anchor.anchorGrade = res.anchorGrade;
                    that.anchor.verifyType = res.verifyType;
                    that.anchor.contractTime = moment(res.contractTime).format('YYYY-MM-DD');
                    if (res.logoPic) {
                        that.anchor.anchorPic = `${that.$store.state.UPLOAD_IMG_HOST}${res.logoPic}`;
                    }
                    that.anchor.personalSignature = res.personalSignature;
                } else {
                    that.anchor.anchorId = null;
                }
                that.anchorLoading = false;
            }).catch(err => {
                this.$message({
                    type: 'error',
                    message: error.message
                });
            });
        },
        getAlbumInfo() {
          axios.get(`/api/manager/requirement/${this.$route.params.id}/album`).then( res => {
            if (res.data.code === 200) {
              const result = res.data.data;
              this.albumForm.albumId = result.albumId;
              this.albumForm.albumStatus = result.albumStatus;
              this.albumForm.anchorId = result.anchorId;
              this.albumForm.title = result.title;
              this.albumForm.paid = result.paid;
              this.albumForm.price = result.price? result.price: 0;
              this.albumForm.discountPrice = result.discountPrice? result.discountPrice: 0;
              this.albumForm.freeEpisode = result.freeTrackCount? result.freeTrackCount: 0;
              this.albumForm.isOnSale = result.published;
              this.albumForm.coverPath = result.coverPath;
            }
          });
        },
        getVoiceList() {
            this.taskWorksList = [];
            this.totalPage = 0;
            axios.get(`/api/requirement/${this.$route.params.id}/task/list/page/${this.pageIndex}`, {}).then(result => {
                if (result.data.code == 200) {
                    if (xm && xm.xmPlayer) {
                      xm.xmPlayer.pause();
                    }
                    const response = result.data.data;
                    if (response && response && response.items.length > 0) {
                        this.taskWorksList = response.items;
                        this.totalPage = response.pages;
                        this.currentPage = response.pageNum;
                        this.totalVoiceCount = response.total;
                        this.pageSize = response.pageSize;
                        setTimeout(() => {
                            $("[sound_id]").xmPlayer();
                        }, 300);
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: result.data.message
                    });
                }
                this.voiceLoading = false;
            }).catch(error => {
                this.$message({
                    type: 'error',
                    message: error.message
                });
            });
        },
        formatDate(time) {
            return moment(time).fromNow();
        },
        openFailed(taskWorkId, taskId) {
            this.$confirm(this.$i18n.t('sen.whyFailedToAuditPlease'), this.$i18n.t('comb.warmTips'), {
                lockScroll: false,
                showInput: true,
                confirmButtonText: this.$i18n.t('word.ok'),
                cancelButtonText: this.$i18n.t('word.cancel'),
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        axios.post(`/api/requirement/task/${taskId}/work/${taskWorkId}/reject`, {
                            rejectedReason: instance.$data.inputValue
                        }).then(result => {
                            if (result.data.code == 200) {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                this.$message({
                                    type: 'success',
                                    message: this.$i18n.t('comb.operationSuccess')
                                });
                                setTimeout(() => {
                                    location.reload();
                                }, 300);
                            }
                        }).catch(error => {
                            done();
                            setTimeout(() => {
                                instance.confirmButtonLoading = false;
                            }, 300);
                            this.$message({
                                type: 'error',
                                message: error.message
                            });
                        });
                    } else {
                        done();
                        instance.confirmButtonLoading = false;
                    }
                }
            }).then(() => {}).catch(() => {});
        },
        openPass(taskWorkId, taskId) {
            this.$confirm(this.$i18n.t('sen.passVoiceAuditConfirm'), this.$i18n.t('comb.warmTips'), {
                lockScroll: false,
                confirmButtonText: this.$i18n.t('word.ok'),
                cancelButtonText: this.$i18n.t('word.cancel'),
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        axios.post(`/api/requirement/task/${taskId}/work/${taskWorkId}/confirm`).then(result => {
                            if (result.data.code == 200) {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                this.$message({
                                    type: 'success',
                                    message: this.$i18n.t('comb.operationSuccess')
                                });
                                setTimeout(() => {
                                    location.reload();
                                }, 300);
                            } else {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                this.$message({
                                    type: 'error',
                                    message: result.data.message
                                });
                            }
                        }).catch(error => {
                            done();
                            instance.confirmButtonLoading = false;
                            this.$message({
                                type: 'error',
                                message: error.message
                            });
                        });
                    } else {
                        done();
                        instance.confirmButtonLoading = false;
                    }
                }
            }).then(() => {}).catch(() => {});
        },
        getTaskStatusId(taskStatusId) {
            this.taskStatusId = taskStatusId;
        },
        getViewStatusId(viewStatusId) {
            this.viewStatusId = viewStatusId;
        },
        setAllowOperate(allowOperate) {
            this.allowOperate = allowOperate;
        },
        getTaskEvaluation(taskEvaluation) {
            this.taskEvaluationObj = taskEvaluation;
        },
        enforce() {
            this.$confirm(this.$i18n.t('sen.finishTaskConfirm'), this.$i18n.t('comb.warmTips'), {
                lockScroll: false,
                confirmButtonText: this.$i18n.t('word.ok'),
                cancelButtonText: this.$i18n.t('word.cancel'),
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        const id = this.$route.params.id;
                        axios.post(`/api/requirement/${id}/task/${this.taskId}/enforce`).then(result => {
                            if (result.data.code == 200) {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                this.$message({
                                    type: 'success',
                                    message: this.$i18n.t('comb.operationSuccess')
                                });
                                setTimeout(() => {
                                    location.reload();
                                }, 300);
                            } else {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                this.$message({
                                    type: 'warning',
                                    message: result.data.message
                                });
                            }
                        }).catch(error => {
                            done();
                            instance.confirmButtonLoading = false;
                            this.$message({
                                type: 'error',
                                message: error.message
                            });
                        });
                    } else {
                        done();
                        instance.confirmButtonLoading = false;
                    }
                }
            }).then(() => {}).catch(() => {});
        },
        openRateAnchor() {
            this.dialogVisible = true;
        },
        closeRate() {
            this.dialogVisible = false;
            this.taskEvaluation = '';
            this.recordQualityScore = this.attitudeScore = this.speedScore = 0;
        },
        closeDialog() {
            this.closeRate();
        },
        changeRecordQualityScore(value) {
            this.recordQualityScore = value;
        },
        changeAttitudeScore(value) {
            this.attitudeScore = value;
        },
        changeSpeedScore(value) {
            this.speedScore = value;
        },
        submitEvaluate() {
            this.submitEvaluateBtnStatus = true;
            const id = this.$route.params.id;
            const recordQualityScore = this.recordQualityScore;
            const attitudeScore = this.attitudeScore;
            const speedScore = this.speedScore;
            const taskEvaluation = this.taskEvaluation;
            axios.post(`/api/requirement/${id}/task/evaluate`, {
                recordQualityScore,
                attitudeScore,
                speedScore,
                taskEvaluation
            }).then(result => {
                if (result.data.code == 200) {
                    this.closeRate();
                    this.submitEvaluateBtnStatus = false;
                    this.$message({
                        type: 'success',
                        message: this.$i18n.t('comb.evaluateSuccessfully')
                    });
                    setTimeout(() => {
                        location.reload();
                    }, 300);
                } else {
                    this.closeRate();
                    this.submitEvaluateBtnStatus = false;
                    this.$message({
                        type: 'warning',
                        message: result.data.message
                    });
                }
            }).catch(error => {
                this.closeRate();
                this.submitEvaluateBtnStatus = false;
                this.$message({
                    type: 'error',
                    message: error.message
                });
            });
        },
        openRefuseBox() {
            this.$confirm(this.$i18n.t('sen.refuseFinishConfirm'), this.$i18n.t('comb.warmTips'),{
                lockScroll: false,
                showInput: true,
                confirmButtonText: this.$i18n.t('word.ok'),
                cancelButtonText: this.$i18n.t('word.cancel'),
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        const id = this.$route.params.id;
                        axios.post(`/api/requirement/${id}/task/${this.taskId}/reject`, {
                            rejectedReason: instance.$data.inputValue
                        }).then(result => {
                            if (result.data.code == 200) {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                this.$message({
                                    type: 'success',
                                    message: this.$i18n.t('comb.operationSuccess')
                                });
                                setTimeout(() => {
                                    location.reload();
                                }, 300);
                            } else {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                this.$message({
                                    type: 'warning',
                                    message: result.data.message
                                });
                            }
                        }).catch(error => {
                            done();
                            this.$message({
                                type: 'error',
                                message: error.message
                            });
                        });
                    } else {
                        done();
                        instance.confirmButtonLoading = false;
                    }
                }
            }).then(() => {}).catch(() => {});
        },
        openAgree() {
            this.$confirm(this.$i18n.t('sen.passFinishConfirm'), this.$i18n.t('comb.warmTips'), {
                lockScroll: false,
                confirmButtonText: this.$i18n.t('word.ok'),
                cancelButtonText: this.$i18n.t('word.cancel'),
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        const id = this.$route.params.id;
                        axios.post(`/api/requirement/${id}/task/${this.taskId}/complete`).then(result => {
                            if (result.data.code == 200) {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                this.$message({
                                    type: 'success',
                                    message: this.$i18n.t('comb.operationSuccess')
                                });
                                setTimeout(() => {
                                    location.reload();
                                }, 300);
                            } else {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                this.$message({
                                    type: 'warning',
                                    message: result.data.message
                                });
                            }
                        }).catch(error => {
                            done();
                            this.$message({
                                type: 'error',
                                message: error.message
                            });
                        });
                    } else {
                        done();
                        instance.confirmButtonLoading = false;
                    }
                }
            }).then(() => {}).catch(() => {});
        },
        lookupEvaluate() {
            this.recordQualityScore = this.taskEvaluationObj.recordQualityScore;
            this.attitudeScore = this.taskEvaluationObj.attitudeScore;
            this.speedScore = this.taskEvaluationObj.speedScore;
            this.taskEvaluation = this.taskEvaluationObj.taskEvaluation;
            this.rateDisabled = true;
            this.dialogVisible = true;
        },
        lookUpBreak() {
            this.breakDialog = true;
        },
        changePage(pageIndex) {
            this.pageIndex = pageIndex;
            this.getVoiceList(pageIndex, this.taskId);
        },
        // 提交专辑定价内容
        commitAlbum() {
          console.log(this.albumForm);
          let url;
          const data = {
            price: this.albumForm.price,
            discountPrice: this.albumForm.discountPrice,
          }
          if (this.albumForm.isOnSale) {
            url = `/api/album/${this.albumForm.albumId}/paid/update`;
          } else {
            url = `/api/album/${this.albumForm.albumId}/paid/release`;
            data.freeTrackCount = this.albumForm.freeEpisode;
          }
          axios.post(url, data).then(res => {
            if (res.data.code === 200) {
              this.$message({
                type: 'info',
                message: '操作成功'
              });
              this.albumForm.isOnSale = true;
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
          this.albumDialog = false;
        }
    },
    computed: {
        UPLOAD_IMG_HOST() {
            return this.$store.state.UPLOAD_IMG_HOST;
        },
        getAlbumUrl () {
            const test = this.$store.state.isTest? 'test.':'';
            let url = 'http://'+test;
            url = url +`ximalaya.com/${this.albumForm.anchorId}/album/${this.albumForm.albumId}`;
            return url;
        },
        vipIconClass () {
            let result = '';
            if(this.anchor.anchorType === 2) {
              result = 'org-vip-level-' + this.anchor.anchorGrade + 'x2';
            } else {
              result = 'personal-vip-level-' + this.anchor.anchorGrade + 'x2';
            }
            return result;
        },
        multiWarmTips() {
            return this.$i18n.t('comb.warmTips');
        },
        multiEvaluateContentMissing() {
            return this.$i18n.t('sen.evaluateContentMissing');
        },
        multiBreakRecord() {
            return this.$i18n.t('comb.breakRecord');
        }
    }
}
</script>
<style lang="sass">@import "../../../sass/copyright/center/task-details-make.scss";</style>



// WEBPACK FOOTER //
// TaskDetailsMaking.vue?26f07143